import React, {useRef, useState, useCallback, useEffect} from 'react';
import PulseLoader from 'react-spinners/PulseLoader'
import {searchForTags} from 'search/tagSearch.js';

export default ({instrument, hide, setSelectedSampler}) => {
    let sequencerEngine = instrument.sequencerEngine;
    const inputRef = useRef(null);
    const [text, setText] = useState('');
    const [noResults, setNoResults] = useState(false);
    const [isSearching, setIsSearching] = useState('');
    const [suggestions, setSuggestions] = useState([]);

    const search = useCallback(async () => {
        let tags = text.split('+').filter(
            tag => tag !== '');
        setIsSearching(true);
        let {sample, samplesStream} = await sequencerEngine.getSample(tags);
        if (sample) {
            let {sampler, samplers} = await instrument.newSample(0, sample, samplesStream);
            setSelectedSampler(sampler);
            hide();
        } else {
            setIsSearching(false);
            setNoResults(true);
        }
    }, [hide, setSelectedSampler, text, setIsSearching, setNoResults]);

    useEffect(() => {
        inputRef.current.focus();
    }, []);

    const onClickSuggestion = useCallback((tag) => {
        let tags = text.split('+');
        tags = [... tags.slice(0, tags.length - 1), tag];
        setText(tags.join('+') + '+');
        loadSuggestions([... tags, '']);
        inputRef.current.focus();
    }, [setText, text, loadSuggestions, setSuggestions, inputRef]);

    const loadSuggestions = useCallback(async (tagsToSearch) => {
        let {suggestions, tags} = await searchForTags(tagsToSearch, instrument.sequencerEngine.searcher);
        let tagsToSuggest = [... tags, ...suggestions];
        setSuggestions(tagsToSuggest);
    }, [setSuggestions]);

    const onChange = useCallback(async (e) => {
        setText(e.target.value);
        let tagsToSearch = e.target.value.split('+');
        if (noResults) {
            setNoResults(false);
        }
        loadSuggestions(tagsToSearch);
    }, [setText, setSuggestions, loadSuggestions, noResults, setNoResults]);

    if (isSearching) {
        return (
            <div className="sample-search-container">
              <PulseLoader
                sizeUnit={"px"}
                size={10}
                color={'#42f4f1'}
                loading={true}
              />
            </div>
        );
 
    }

    return (
        <div className="sample-search-container">
          <div className="search-box-container">
            <input
              value={text}
              ref={inputRef}
              placeholder='Type sample tags to search'
              onChange={onChange}
              type="text" className="sample-search"
            />
            <div
              onClick={search}
              className="search-button">
              Search
            </div>
          </div>
          {noResults ? <div className="no-results">No Results</div> : ''}
          <div className="suggestions">
            {suggestions.map(
                suggestion =>
                    <div
                      onClick={() => onClickSuggestion(suggestion)}
                      className="suggestion">
                      {suggestion}
                    </div>)}
          </div>
        </div>
    );
};
